import * as React from 'react'

import styled from 'styled-components'
import { darkSlateBlue, paleGray } from '../../../styles/settings/colors'

const Svg = styled.svg`
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  ${({ disabled }) => disabled && `pointer-events: none`};
  width: '20px';
  right: '20px';
  background-color: ${paleGray};
  border-radius: 50%;
  &:hover {
    background-color: ${darkSlateBlue};
    path {
      stroke: white;
    }
  }
`

function ChevronRight(props) {
  return (
    <Svg
      width="20px"
      height="20px"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            '.prefix__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'
          }
        </style>
      </defs>
      <title />
      <g id="prefix__chevron-right">
        <path className="prefix__cls-1" d="M21 16l-9 9M12 7l9 9" />
      </g>
    </Svg>
  )
}

export default ChevronRight



// WEBPACK FOOTER //
// ./src/app/elements/Icons/ChevronRight.js